import { isTourOfferType } from 'lib/offerTypes'
import { pluralizeToString } from 'lib/pluralize'

export function getDurationLabel(duration: number, offerType: App.OfferType) {
  const timeUnit = isTourOfferType(offerType) ? 'day' : 'night'
  return pluralizeToString(timeUnit, duration)
}
